import { FC, Fragment } from 'react';
import cx from 'classnames';
import {
  HeaderAccountFeatureProps,
  HeaderAccountFeatureLinkProps,
} from './types';
import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import styles from './HeaderAccountFeatures.module.scss';

export const HeaderAccountFeatures: FC<HeaderAccountFeatureProps> = ({
  features,
}) => {
  return (
    <div className={cx(styles['header__features-menu--drawer-content'])}>
      <hr className={cx(styles['header__features-menu--divider'])} />
      <CatList spacing="padded">
        {features?.map(
          ({ label, helperText, link, isActive, isStatic, onClick, dataTrackEvent,
            dataTrackText,
            dataTrackContext }: HeaderAccountFeatureLinkProps) =>
            label ? (
              <Fragment key={label}>
                <CatListItem
                  href={link}
                  isActive={isActive}
                  isStatic={isStatic}
                  onBlSelect={onClick}
                  data-testid="cat-features-menu-list-item"
                  data-track-event={dataTrackEvent}
                  data-track-attr-nltext={dataTrackText}
                  data-track-attr-context={dataTrackContext}
                >
                  <div>
                    <span
                      className={cx(
                        styles['header__features-menu--drawer-item']
                      )}
                    >
                      {label}
                    </span>
                    <br />
                    <span
                      className={cx(
                        styles['header__features-menu--drawer--helper-text']
                      )}
                    >
                      {helperText}
                    </span>
                  </div>
                </CatListItem>
                <hr className={cx(styles['header__features-menu--divider'])} />
              </Fragment>
            ) : null
        )}
      </CatList>
    </div>
  );
};
